import React from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const ActiveUser = () => {


    const columns = [
        { name: "Username", selector: (row, index) => row.userName, sortable: true },
        { name: "Full Name", selector: (row, index) => <span> {row.state} <i class="fa fa-envelope-o" aria-hidden="true" style={{backgroundColor:"yellow"}}></i> </span>, sortable: true },
    ];

    const players = [
        { userName: "pia", state: '	Pia Guzman' },
        { userName: "racket", state: 'deepti verma' },

    ];

    const customStyles = {
        table: {
            style: {
                border: "1px solid #ddd",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#40444d", // Black header row
                color: "#ffffff", // White text for header
            },
        },
        rows: {
            style: {
                "&:nth-of-type(odd)": {
                    backgroundColor: "#dedfdd", // Red background for odd rows
                    // color: "#dedfdd", // White text for odd rows
                },
                "&:nth-of-type(even)": {
                    backgroundColor: "#ffffff", // White background for even rows
                    // color: "#000000", // Black text for even rows
                },
            },
        },
    };
    const buttonStyle = {
        background: "#9cb23b",
        padding: "10px 10px",
        margin: "10px 0px",
        border: "none",
        borderRadius: "25px",
        minWidth: "120px",
        color: "#fff",
        cursor: "pointer", // Optional: Adds pointer cursor
        textAlign: "center",
        marginRight: "20px"
        
    };
    
    return (
        <div id="page-admin-users" className="page-admin">
            <DataTable
                columns={columns}
                data={players}
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
            />

            {/* <button style={buttonStyle} to="manageCourse.html">Manage Courses</button>
            <button  style={buttonStyle} to="registrationCity.html">Add New City</button> */}
            
        </div>
    )
}
export default ActiveUser;